module.exports = __webpack_public_path__ + "img/se.1074a609.svg";